export enum DocumentType {
    GeneralInformation = 0,

    ShiftSchedule = 1
}
